import api from "@/api";
import i18n from "@/i18n";
import { createLatestRequestGate, parseApiError, parseCollectionAuthorization } from "@/helpers/teamAuthorization";

const { t } = i18n.global;
const secondCategoryRequestGate = createLatestRequestGate();
export default {
  state: {
    secondSaleCategories: [],
    secondSaleCategoriesData: {},
    secondSaleCategoryTeamId: 0,
    collectionAuthorization: null,
    collectionError: null,
  },
  getters: {
    secondSaleCategories: (state) => state.secondSaleCategories,
    secondSaleCategoriesData: (state) => state.secondSaleCategoriesData,
    secondSaleCategoryTeamId: (state) => state.secondSaleCategoryTeamId,
    secondSaleCategoryCollectionAuthorization: (state) => state.collectionAuthorization,
    secondSaleCategoryCollectionError: (state) => state.collectionError,
  }, 
  mutations: {
    setSecondSaleCategories: (state, data) => {
      state.secondSaleCategories = data;
    },

    setSecondSaleCategoriesData: (state, data) => {
      state.secondSaleCategoriesData = data;
    },

    setSecondSaleCategoryTeamId: (state, data) => {
      state.secondSaleCategoryTeamId = data;
    },
    setSecondSaleCategoryCollectionAuthorization: (state, data) => {
      state.collectionAuthorization = data;
    },
    setSecondSaleCategoryCollectionError: (state, data) => {
      state.collectionError = data;
    },
  },
  actions: {

    deleteSecondSaleCategory: async (_, { id, teamId }) => {
      try {
        await api({ requiresAuth: true }).delete(
            `/v1/sales-categories/${id}`,
            { data: { team_id: teamId } }
        );
      } catch (err) {
        console.error(err);
      }
    },

    getSecondSaleCategories: async ({ commit }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/sales-categories-second-agent"
        ); 
        const { data } = response;
        commit("setSecondSaleCategories", data);
      } catch (err) {
        console.error(err);
      }
    },

    getSecondSaleCategoriesByTeam: async ({ commit }, teamId) => {
      const requestKey = `second-sales-categories:${teamId}`;
      const { signal } = secondCategoryRequestGate.start(requestKey);
      commit("setSecondSaleCategories", []);
      commit("setSecondSaleCategoryCollectionAuthorization", null);
      commit("setSecondSaleCategoryCollectionError", null);
      try {
        const response = await api({ requiresAuth: true }).get(
          `/v1/teams/${teamId}/sales-categories-second-agent`,
          { signal }
        );
        if (!secondCategoryRequestGate.isActive(requestKey)) return;
        commit("setSecondSaleCategories", response.data);
        commit("setSecondSaleCategoryCollectionAuthorization", parseCollectionAuthorization(response));
      } catch (err) {
        if (err.code === "ERR_CANCELED" || !secondCategoryRequestGate.isActive(requestKey)) return;
        commit("setSecondSaleCategoryCollectionError", parseApiError(err));
      }
    },

    getSecondSaleCategoriesFormData: async ({ commit }, teamId) => {
      try {
        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          "/v1/partials/sales-categories-forms",
          { params: { team_id: teamId } }
        );
        commit("setSecondSaleCategoriesData", data);
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.somethingWentWrong"),
        });
      }
    },

    addSecondSaleCategory: async ({ commit }, { title, provision, teamId }) => {
      try {
        await api({ requiresAuth: true }).post("/v1/sales-categories", {
          title,
          agent_provision: provision,
          team_id: teamId,
          is_secondary: true
        });
        commit("setToast", {
          display: true,
          type: "success",
           message: t("messages.saleCategoryCreatedSuccessfully"),
        });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.somethingWentWrong"),
        });
        throw err;
      }
    },
  },
};
